import React from 'react'

import { cn } from '@/lib/utils'

const PageContainer: React.FC<React.ComponentProps<'div'>> = ({
  className,
  children,
  ...props
}) => (
  <div className={cn('mx-auto w-full', className)} {...props}>
    {children}
  </div>
)

export default PageContainer
